import * as React from "react";
import Modal from "../ui/modal/Modal";
import ButtonPrimary from "../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface ComponentProps {
	/**
	 * On close action.
	 */
	onClose: () => void;
	/**
	 * On confirm action.
	 */
	onConfirm: () => void;
}

type Props = ComponentProps;

export default class ConfirmDeleteAppointmentModal extends React.PureComponent<Props, {}> {
	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={"Confirm"} autoWidth={true}>
				<div style={{width: "500px"}}>
					<p>Are you sure you would like to delete this appointment? If it's confirmed please contact prospect before
						proceeding</p>
					<ButtonTertiary label={"Cancel"} onClick={this.props.onClose}/>
					<div className={"pull-right"}>
						<ButtonPrimary label={"Process"} onClick={() => {this.props.onConfirm()}}/>
					</div>
				</div>
			</Modal>
		)
	}
}